<template>
  <list-template
      :loading="loading"
      :total="total"
      :table-data="tableData"
      :current-page="page"
      :table-config="tableConfig"
      :search-config="searchConfig"
      @onAdd="$router.push('./add')"
      @onSearch="onSearch"
      @onChangePage="handleCurrentChange"
      @onHandle="onHandle"
  />

</template>
<script>
import listTemplate from "@/components/pages/List"
import { tableListMixin } from '@/utils/mixins'
import { zhGet, zh_opt_history, changeObjToArr } from '@/api'
import { setConfigOption } from '@/utils'

export default {
  _config: {route: {path: "list", meta: {title: "列表", keepAlive: true}}},
  mixins: [tableListMixin],
  components: {listTemplate},
  data() {
    return {
      searchConfig: [
          // 筛选教材版本,筛选教材名称,筛选所属学科,筛选应用学段
          {
            prop: "teach_name",
            tag: "select",
            placeholder: "筛选教材名称",
            options: []
          },
          {
            prop: "subject_id",
            tag: "select",
            placeholder: "筛选所属学科",
            options: []
          },
      ],
      tableConfig: [
          //教材版本,所属学科,教材名称,应用学段,章节总数,关联视频总数,操作
          {
            prop: "teach_name",
            label: "教材名称"
          },
          {
            prop: "subject_name",
            label: "学科"
          },
          {
            prop:"creator",
            label:"创建人"
          },
          {
            prop:"created_at",
            label:"创建时间"
          },
          {
            label: "操作",
            handle: true
          }
      ],
    }
  },
  mounted() {
    this.getSearchConfig()
  },
  activated() {
    // 所属学科
    this.getSubject()
  },
  methods: {
    getData() {
      this.getDataApi('/wisdom-education/video/list-article')
    },
    getSubject() {
      zhGet('/video/search-article', { search_type: 'subject_id' }).then(res => {
      setConfigOption({ list: this.searchConfig, data: changeObjToArr(res, true), key: 'subject_id'})
    })
    },
    getSearchConfig() {
      // 教材名称
      zhGet('/video/search-article', { search_type: 'teach_name' }).then(res => {
        setConfigOption({ list: this.searchConfig, data: changeObjToArr(res), key: 'teach_name'})
      })
      // 所属学科
      this.getSubject()
    },
    onHandle(row, p) {
      // list button handle ...
      switch (p.type){
        case "edit":
          this.$router.push("./edit?id="+row.id);
          break;
        case "viewHistory":
          zh_opt_history({ type: 'video_article_config', id: row.id }).then(res=>{
            this.$historyRecord({
              data: res.list
            })
          })
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
